import PageMeta from "../../components/common/PageMeta";
import {
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
} from "../../utilities/constants";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import Tabs from "../../components/ui/Tabs"
import TemplatePage from "./TemplatePage";
import TemplateHistoryPage from "./TemplateHistoryPage";

const NotificationPage = () => {
   
    return (
        <>
            <PageMeta
                title={`Notification - ${DEFAULT_PAGE_TITLE}`}
                description={`Notification - ${DEFAULT_PAGE_DESCRIPTION}`}
            />
            <PageBreadcrumb pageTitle="Notification" />
            <Tabs
                tabs={[
                     {
                        label: "Template",
                        content: (
                            <div>
                                <div>
                                    <TemplatePage />
                                </div>
                            </div>
                        ),
                    },
                    {
                        label: "History",
                        content: (
                            <div>
                                {/* <div className="flex items-center gap-2 mb-4">
                                    <FaCrown className="w-5 h-5 text-[#CA8A04]" />
                                    <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                                        History
                                    </h3>
                                </div> */}
                                 <div>
                                    <TemplateHistoryPage />
                                </div>

                            </div>
                        ),
                    },
                   
                ]}
            />

        </>
    );
};

export default NotificationPage;
